var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":_vm.title,"form":true,"propActions":_vm.submitAction},on:{"submit":_vm.submit}}),_c('Interface',{attrs:{"noHeader":""}},[_c('Form',_vm._b({ref:"form",on:{"finished":_vm.finished,"invalid":_vm.invalid}},'Form',_vm.$props,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }